// extracted by mini-css-extract-plugin
module.exports = {"input":"TextArea_input__1PU5S"};